// Moved simple str coercion file to helpers
// Use case is for t tags in placeholders/labels which return str | undefined
// This helper returns str or "" to assist i18 typing
export function str(v: unknown): string {
  return typeof v === "string" ? v : "";
}
